// extracted by mini-css-extract-plugin
export default {"languageDot":"LanguageDot-module__languageDot__VTDkA74","languageDotCompact":"LanguageDot-module__languageDotCompact__fEYCXhY"};